/* global window, document */

(function (window, document) {
    'use strict';

    var mount = document.getElementById('vg-dyk-mount');
    if (!mount) return;

    var mapEl = document.getElementById('appaltimap-map');
    var TIPS_URL = (mount.getAttribute('data-tips-url') || '').trim();
    var SEEN_PREFIX = 'vg_dyk_seen_ids_';
    var DISMISS_PREFIX = 'vg_dyk_dismissed_';
    var SESSION_CLOSED = 'vg_dyk_closed_this_session';

    var state = {
        tips: [],
        assetRefs: {},
        audience: null,
        currentTip: null,
        root: null,
        backdrop: null,
        onKeydownHandler: null,
        manualOpen: false,
        tipsReady: false
    };

    function isCompactMode(audience) {
        return audience === 'paid';
    }

    function isPaidMember(el) {
        var paid = (el.getAttribute('data-member-paid') || '').trim().toLowerCase();
        return paid === 'true' || paid === '1' || paid === 'yes';
    }

    function getAudience() {
        var html = document.documentElement;
        var uuid = (html.getAttribute('data-member-uuid') || '').trim();
        if (!uuid) return 'anonymous';
        if (isPaidMember(html)) return 'paid';
        return 'registered_free';
    }

    function apiBase() {
        var base = (document.documentElement.getAttribute('data-api-base') || '').trim();
        return base ? base.replace(/\/+$/, '') : '/api';
    }

    /** Allinea data-member-paid se Ghost SSR non ha @member.paid ma la sessione è Radar. */
    function refreshPaidFromSession() {
        var html = document.documentElement;
        if (!html.getAttribute('data-member-uuid') || isPaidMember(html)) {
            return Promise.resolve();
        }
        return fetch('/members/api/session/', { method: 'GET', credentials: 'include' })
            .then(function (r) {
                if (r.status === 204 || !r.ok) return null;
                return r.text();
            })
            .then(function (token) {
                token = (token || '').trim();
                if (!token) return null;
                return fetch(apiBase() + '/auth/ghost/session/verify', {
                    method: 'POST',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: JSON.stringify({ session_token: token })
                }).then(function (r2) {
                    return r2.ok ? r2.json() : null;
                });
            })
            .then(function (data) {
                if (!data || !data.valid) return;
                var paid = !!(data.plans && data.plans.is_paid) ||
                    !!(data.member && data.member.paid) ||
                    (data.plans && data.plans.active_tiers && data.plans.active_tiers.length > 0);
                if (paid) {
                    html.setAttribute('data-member-paid', 'true');
                }
            })
            .catch(function () {});
    }

    function readJsonScript(id) {
        var el = document.getElementById(id);
        if (!el || !el.textContent) return null;
        try {
            return JSON.parse(el.textContent);
        } catch (e) {
            return null;
        }
    }

    function isDismissed(tipId) {
        try {
            return localStorage.getItem(DISMISS_PREFIX + tipId) === '1';
        } catch (e) {
            return false;
        }
    }

    function getSeenIds(audience) {
        try {
            var raw = localStorage.getItem(SEEN_PREFIX + audience);
            if (!raw) return [];
            var arr = JSON.parse(raw);
            return Array.isArray(arr) ? arr : [];
        } catch (e2) {
            return [];
        }
    }

    function pushSeenId(audience, tipId) {
        try {
            var list = getSeenIds(audience).filter(function (id) { return id !== tipId; });
            list.unshift(tipId);
            if (list.length > 20) list.length = 20;
            localStorage.setItem(SEEN_PREFIX + audience, JSON.stringify(list));
        } catch (e) {}
    }

    function canShowTip(audience, cooldownDays) {
        if (audience === 'anonymous') {
            try {
                return sessionStorage.getItem(SESSION_CLOSED) !== '1';
            } catch (e) {
                return true;
            }
        }
        var key = 'vg_dyk_last_seen_' + audience;
        try {
            var lastSeen = localStorage.getItem(key);
            if (!lastSeen) return true;
            var days = typeof cooldownDays === 'number' ? cooldownDays : parseInt(cooldownDays, 10);
            if (!days || days <= 0) days = 3;
            var last = new Date(lastSeen).getTime();
            var diffDays = (Date.now() - last) / (1000 * 60 * 60 * 24);
            return diffDays >= days;
        } catch (e2) {
            return true;
        }
    }

    function markTipSeen(audience) {
        if (audience === 'anonymous') {
            try {
                sessionStorage.setItem(SESSION_CLOSED, '1');
            } catch (e) {}
            return;
        }
        try {
            localStorage.setItem('vg_dyk_last_seen_' + audience, new Date().toISOString());
        } catch (e2) {}
    }

    function trackDidYouKnow(type, tip, audience, source, trigger) {
        var detail = {
            type: type,
            tipId: tip.id,
            audience: audience,
            ctaTarget: tip.ctaTarget,
            source: source || null,
            trigger: trigger || null
        };
        try {
            window.dispatchEvent(new CustomEvent('vg:did_you_know', { detail: detail }));
        } catch (e) {}

        var paq = window._paq;
        if (!paq || !paq.push) return;
        var name = [tip.id, audience, tip.ctaTarget || '', source || '', trigger || ''].join('|');
        paq.push(['trackEvent', 'DidYouKnow', type, name]);
    }

    function openPortal(route) {
        var portal = route || 'account/plans';
        var sel = '[data-portal="' + portal + '"]';
        var tries = 0;
        function attempt() {
            tries += 1;
            var a = document.querySelector(sel);
            if (a && typeof a.click === 'function') {
                try { a.click(); } catch (e) {}
                return;
            }
            try {
                var hash = '#/portal/' + portal;
                if (window.location.hash !== hash) {
                    window.location.hash = hash;
                }
            } catch (e2) {}
            if (tries < 10) {
                window.setTimeout(attempt, 250);
            }
        }
        attempt();
    }

    function triggerHomeFeature(action) {
        if (!action) return false;
        if (action === 'cpv-focus') {
            var input = document.getElementById('appaltimap-cpv-query');
            if (input) {
                input.focus();
                input.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                return true;
            }
            return false;
        }
        if (action === 'bug-report') {
            var bugBtn = document.querySelector('[data-vg-bug-report]');
            if (bugBtn && typeof bugBtn.click === 'function') {
                bugBtn.click();
                return true;
            }
            return false;
        }
        if (action === 'tools-menu') {
            var toggle = document.querySelector('[data-vg-tools-toggle]');
            if (toggle && typeof toggle.click === 'function') {
                toggle.click();
                return true;
            }
            return false;
        }
        var btn = document.querySelector('[data-appaltimap-action="' + action + '"]');
        if (btn && typeof btn.click === 'function') {
            btn.click();
            return true;
        }
        return false;
    }

    function handleTipCta(tip, audience) {
        if (audience === 'paid' && tip.ctaTarget === 'feature') {
            if (tip.featureAction && triggerHomeFeature(tip.featureAction)) {
                return;
            }
            if (tip.featureUrl) {
                window.location.href = tip.featureUrl;
                return;
            }
            return;
        }
        if (tip.ctaTarget === 'radar_landing') {
            window.location.href = '/vistagare-radar/';
            return;
        }
        if (tip.ctaTarget === 'portal_signup') {
            openPortal('signup');
            return;
        }
        openPortal('account/plans');
    }

    function selectRandomTip(tips, audience) {
        var pool = tips.filter(function (tip) {
            return tip && tip.id && tip.audience && tip.audience.indexOf(audience) !== -1;
        });
        if (!pool.length) return null;
        return pool[Math.floor(Math.random() * pool.length)];
    }

    function selectRandomTipForHeader(tips, audience) {
        var tip = selectRandomTip(tips, audience);
        if (tip) return tip;
        if (audience === 'paid') {
            tip = selectRandomTip(tips, 'registered_free');
            if (tip) return tip;
        }
        if (audience !== 'anonymous') {
            tip = selectRandomTip(tips, 'anonymous');
            if (tip) return tip;
        }
        return tips.length ? tips[Math.floor(Math.random() * tips.length)] : null;
    }

    function selectTip(tips, audience) {
        var seen = getSeenIds(audience);
        var available = tips
            .filter(function (tip) {
                if (!tip || !tip.id || !tip.audience || tip.audience.indexOf(audience) === -1) {
                    return false;
                }
                if (isDismissed(tip.id)) return false;
                if (!canShowTip(audience, tip.cooldownDays)) return false;
                return true;
            })
            .sort(function (a, b) {
                return (b.priority || 0) - (a.priority || 0);
            });

        if (!available.length) return null;

        var fresh = available.filter(function (t) { return seen.indexOf(t.id) === -1; });
        var pool = fresh.length ? fresh : available;
        return pool[Math.floor(Math.random() * pool.length)];
    }

    function isAiModalOpen() {
        var ai = document.querySelector('[data-vg-ai-modal]');
        if (!ai) return false;
        if (typeof ai.hidden === 'boolean') return ai.hidden === false;
        return !ai.hasAttribute('hidden') && ai.getAttribute('aria-hidden') === 'false';
    }

    function isBlockingModalOpen(options) {
        options = options || {};
        if (isAiModalOpen()) return true;
        if (document.querySelector('.vg-bug-report-modal')) return true;
        if (!options.ignoreDykOpen && state.root) return true;
        return false;
    }

    function closeWidget() {
        if (state.onKeydownHandler) {
            document.removeEventListener('keydown', state.onKeydownHandler);
            state.onKeydownHandler = null;
        }
        if (state.backdrop && state.backdrop.parentNode) {
            state.backdrop.parentNode.removeChild(state.backdrop);
            state.backdrop = null;
        }
        if (state.root && state.root.parentNode) {
            state.root.parentNode.removeChild(state.root);
            state.root = null;
        }
        document.body.classList.remove('vg-dyk-open', 'vg-dyk-open--compact', 'vg-dyk-open--promo');
    }

    function onClose(tip, audience, dismissed) {
        if (dismissed && tip) {
            try {
                localStorage.setItem(DISMISS_PREFIX + tip.id, '1');
            } catch (e) {}
        }
        if (!state.manualOpen) {
            markTipSeen(audience);
        }
        if (tip) {
            pushSeenId(audience, tip.id);
            trackDidYouKnow('closed', tip, audience, null, state.manualOpen ? 'header_icon' : 'auto');
        }
        state.manualOpen = false;
        closeWidget();
    }

    function onCta(tip, audience, source) {
        if (!state.manualOpen) {
            markTipSeen(audience);
        }
        pushSeenId(audience, tip.id);
        trackDidYouKnow('cta_clicked', tip, audience, source, state.manualOpen ? 'header_icon' : 'auto');
        state.manualOpen = false;
        closeWidget();
        handleTipCta(tip, audience);
    }

    function renderWidget(tip, audience, options) {
        options = options || {};
        closeWidget();
        state.manualOpen = !!options.manual;

        /* Click ℹ️: modale centrale sempre visibile; auto-popup paganti resta compatto. */
        var compact = !options.manual && isCompactMode(audience);
        var thumbUrl = null;
        if (tip.thumbnailId && state.assetRefs[tip.thumbnailId]) {
            thumbUrl = state.assetRefs[tip.thumbnailId];
        }

        var dismissCheck;

        if (!compact) {
            var backdrop = document.createElement('button');
            backdrop.type = 'button';
            backdrop.className = 'vg-dyk__backdrop';
            backdrop.setAttribute('aria-label', 'Chiudi suggerimento');
            backdrop.addEventListener('click', function () {
                onClose(tip, audience, dismissCheck && dismissCheck.checked);
            });
            document.body.appendChild(backdrop);
            state.backdrop = backdrop;
        }

        var root = document.createElement('div');
        root.className = 'vg-dyk' + (compact ? ' vg-dyk--compact' : ' vg-dyk--promo');
        root.setAttribute('role', 'dialog');
        root.setAttribute('aria-modal', compact ? 'false' : 'true');
        root.setAttribute('aria-labelledby', tip.title ? 'vg-dyk-title' : 'vg-dyk-eyebrow');
        root.id = 'vg-dyk-dialog';

        var inner = document.createElement('div');
        inner.className = 'vg-dyk__inner';

        var closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'vg-dyk__close';
        closeBtn.setAttribute('aria-label', 'Chiudi suggerimento');
        closeBtn.innerHTML = '&times;';

        var grid = document.createElement('div');
        grid.className = 'vg-dyk__grid';

        if (thumbUrl) {
            var thumbBtn = document.createElement('button');
            thumbBtn.type = 'button';
            thumbBtn.className = 'vg-dyk__thumb';
            thumbBtn.setAttribute('aria-label', tip.ctaLabel || 'Azione suggerimento');
            var img = document.createElement('img');
            img.src = thumbUrl;
            img.alt = (tip.thumbnailAlt || tip.body || '').slice(0, 120);
            img.loading = 'lazy';
            img.decoding = 'async';
            if (compact) {
                img.width = 120;
                img.height = 80;
            } else {
                img.width = 480;
                img.height = 220;
            }
            thumbBtn.appendChild(img);
            thumbBtn.addEventListener('click', function () {
                onCta(tip, audience, 'thumbnail');
            });
            grid.appendChild(thumbBtn);
        }

        var copy = document.createElement('div');
        copy.className = 'vg-dyk__copy';

        var eyebrow = document.createElement('p');
        eyebrow.className = 'vg-dyk__eyebrow';
        eyebrow.id = 'vg-dyk-eyebrow';
        eyebrow.textContent = 'Sapevi che...';

        var title = document.createElement('h3');
        title.className = 'vg-dyk__title';
        title.id = 'vg-dyk-title';
        title.textContent = tip.title || 'Un suggerimento per te';

        var body = document.createElement('p');
        body.className = 'vg-dyk__body';
        body.textContent = tip.body || '';

        var actions = document.createElement('div');
        actions.className = 'vg-dyk__actions';

        var cta = document.createElement('button');
        cta.type = 'button';
        cta.className = 'vg-dyk__cta';
        cta.textContent = tip.ctaLabel || 'Continua';

        var dismissLabel = document.createElement('label');
        dismissLabel.className = 'vg-dyk__dismiss';
        dismissCheck = document.createElement('input');
        dismissCheck.type = 'checkbox';
        dismissCheck.className = 'vg-dyk__dismiss-input';
        dismissLabel.appendChild(dismissCheck);
        dismissLabel.appendChild(document.createTextNode(' Non mostrare più questo suggerimento'));

        actions.appendChild(cta);
        actions.appendChild(dismissLabel);

        copy.appendChild(eyebrow);
        if (tip.title) copy.appendChild(title);
        copy.appendChild(body);
        copy.appendChild(actions);

        grid.appendChild(copy);
        inner.appendChild(closeBtn);
        inner.appendChild(grid);
        root.appendChild(inner);

        closeBtn.addEventListener('click', function () {
            onClose(tip, audience, dismissCheck.checked);
        });
        cta.addEventListener('click', function () {
            onCta(tip, audience, 'cta');
        });

        document.body.appendChild(root);
        state.root = root;
        state.currentTip = tip;
        state.audience = audience;

        document.body.classList.add('vg-dyk-open', compact ? 'vg-dyk-open--compact' : 'vg-dyk-open--promo');
        root.removeAttribute('hidden');
        root.setAttribute('aria-hidden', 'false');

        state.onKeydownHandler = function (ev) {
            if (ev.key === 'Escape' && state.root) {
                var chk = state.root.querySelector('.vg-dyk__dismiss-input');
                onClose(state.currentTip, state.audience, chk && chk.checked);
            }
        };
        document.addEventListener('keydown', state.onKeydownHandler);

        if (!compact && cta.focus) {
            window.setTimeout(function () { cta.focus(); }, 50);
        }

        trackDidYouKnow('shown', tip, audience, null, state.manualOpen ? 'header_icon' : 'auto');
    }

    function showTipAuto() {
        if (isBlockingModalOpen()) return;
        state.audience = getAudience();
        var tip = selectTip(state.tips, state.audience);
        if (!tip) return;
        renderWidget(tip, state.audience, { manual: false });
    }

    function showTipFromHeader() {
        if (!state.tips.length) return;
        if (isBlockingModalOpen({ ignoreDykOpen: true })) return;
        state.audience = getAudience();
        var tip = selectRandomTipForHeader(state.tips, state.audience);
        if (!tip) return;
        renderWidget(tip, state.audience, { manual: true });
    }

    function onHeaderTriggerClick(e) {
        var btn = e.target && e.target.closest('[data-vg-dyk-trigger]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        function run() {
            showTipFromHeader();
        }
        refreshPaidFromSession().then(function () {
            if (!state.tipsReady) {
                loadTips().then(function (tips) {
                    state.tips = tips;
                    state.tipsReady = tips.length > 0;
                    run();
                });
                return;
            }
            run();
        });
    }

    function loadTips() {
        if (!TIPS_URL) return Promise.resolve([]);
        return fetch(TIPS_URL, { credentials: 'same-origin' })
            .then(function (r) {
                if (!r.ok) throw new Error('tips HTTP ' + r.status);
                return r.json();
            })
            .then(function (data) {
                if (Array.isArray(data)) return data;
                if (data && Array.isArray(data.tips)) return data.tips;
                return [];
            })
            .catch(function () {
                return [];
            });
    }

    function scheduleAutoShow() {
        if (!mapEl) return;
        var delay = 2800;
        function run() {
            if (state.tips.length) showTipAuto();
        }
        if (typeof window.requestIdleCallback === 'function') {
            window.requestIdleCallback(function () {
                window.setTimeout(run, delay);
            }, { timeout: delay + 2000 });
        } else {
            window.setTimeout(run, delay);
        }
    }

    function bindHeaderTriggers() {
        if (document.documentElement.getAttribute('data-vg-dyk-delegation') === '1') return;
        document.documentElement.setAttribute('data-vg-dyk-delegation', '1');
        document.addEventListener('click', onHeaderTriggerClick, true);
    }

    function init() {
        state.assetRefs = readJsonScript('vg-dyk-asset-refs') || {};
        bindHeaderTriggers();
        refreshPaidFromSession();
        loadTips().then(function (tips) {
            state.tips = tips;
            state.tipsReady = tips.length > 0;
            if (!tips.length) return;
            scheduleAutoShow();
        });
    }

    window.VistaGareDidYouKnow = {
        showRandom: showTipFromHeader
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
}(window, document));
